import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { fetchUserData } from "../../../../redux/reduxApi/SingIn&SingUp/SinginApi";

export default function EmailVerification() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { email, userId } = location.state || {};

  const [otp, setOtp] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);

  if (!email || !userId) {
    return <div>Invalid access. Missing email or user information.</div>;
  }

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const handleVerify = async () => {
    if (otp.length === 0) {
      toast.error("Please enter OTP");
      return;
    }
    setIsVerifying(true);
    try {
      const response = await axios.post(
        "http://localhost:3001/server/backend_function/webapp/customers/api/v1/verify-Customer",
        {
          email,
          otp,
          phone: "", // phone can be empty or omitted if not needed here
          phoneOtp: "",
        }
      );
      if (response.data.success) {
        toast.success("Email verified successfully");
        // Update email in DB after successful OTP verification
        await axios.put(
          `http://localhost:3001/server/backend_function/admin/customer/api/v1/update-customer/${userId}`,
          { email }
        );
        dispatch(fetchUserData(userId)); // Refresh user data in store
        navigate("/account/edit-account"); // Navigate back to CustomerAccountForm
      } else {
        toast.error("OTP verification failed");
      }
    } catch (error) {
      toast.error("Error verifying OTP");
      console.error(error);
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 border rounded shadow">
      <h2 className="text-xl font-bold mb-4">Verify Your Email</h2>
      <p className="mb-4">An OTP has been sent to your email: {email}</p>
      <input
        type="text"
        value={otp}
        onChange={handleOtpChange}
        placeholder="Enter OTP"
        className="w-full p-2 border rounded mb-4"
      />
      <button
        onClick={handleVerify}
        disabled={isVerifying}
        className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 disabled:opacity-50"
      >
        {isVerifying ? "Verifying..." : "Verify"}
      </button>
    </div>
  );
}
